import React from 'react';
import { useReveal, PageHero } from '../Components/shared';
import MailForm from '../Components/mailForm';
import { PillarIcon } from '../Components/icons';

const ROLES = [
  { icon: 'learn', title: 'Learner', body: 'Join a cohort and build real IT skills through hands-on learning and mentorship.' },
  { icon: 'community', title: 'Mentor or volunteer', body: 'Share what you know, run a session, or help us reach more communities.' },
  { icon: 'code', title: 'Partner', body: 'Sponsor a cohort, host a programme, or bring us a project for our engineering team.' },
];

const FIELDS = [
  { name: 'name', label: 'Full name', required: true, autoComplete: 'name' },
  { name: 'email', label: 'Email', type: 'email', required: true, autoComplete: 'email' },
  { name: 'phone', label: 'Phone (optional)', type: 'tel', autoComplete: 'tel' },
  { name: 'role', label: 'I want to join as', type: 'select', required: true,
    options: ['Learner', 'Mentor', 'Volunteer', 'Partner / Sponsor'] },
  { name: 'about', label: 'Tell us about yourself', type: 'textarea', wide: true,
    placeholder: 'Your background, what you hope to learn or contribute…' },
];

function JoinUs() {
  const ref = useReveal();
  return (
    <main id="main" ref={ref}>
      <PageHero
        eyebrow="Join us"
        title={['Find your place', 'in the community.']}
        lead="EMANAC grows through the people in it. Learners, mentors, volunteers and partners are all welcome."
        photo="girlsLaptopPointing"
      />
      <section className="section">
        <div className="wrap">
          <ul className="roles">
            {ROLES.map((r, i) => (
              <li key={r.title} className="role" data-reveal style={{ '--d': i }}>
                <span className="icon-chip"><PillarIcon name={r.icon} /></span>
                <h2 className="h3">{r.title}</h2>
                <p className="body">{r.body}</p>
              </li>
            ))}
          </ul>
          <div className="form-block" id="register">
            <div data-reveal>
              <p className="kicker">Register</p>
              <h2 className="h2">Tell us a little about you.</h2>
              <p className="lead">Share how you'd like to be involved and we'll get back to you with next steps.</p>
            </div>
            <div data-reveal>
              <MailForm fields={FIELDS} submitLabel="Send registration"
                subject={(d) => `[Join EMANAC] ${d.get('role')}: ${d.get('name')}`} />
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default JoinUs;
